import React from 'react'
import PropTypes from 'prop-types'

const HeaderAction = ({ title, hideUnder, isCentered, right, redirectUrl, isButton, dataAttr }) => {
  return (
    <div
      className={`item ${isButton ? 'header-button' : 'header-link'}${
        hideUnder ? ` hide-under-${hideUnder}-screen` : ''
      }${isCentered ? ' centered-header-button' : ''}${right ? ' push-right' : ''}`}
    >
      <a
        style={{ minWidth: isButton ? `${title.length * 9}px !important` : 'unset' }}
        className={isButton ? '' : 'header-link'}
        href={redirectUrl}
        data-attr={dataAttr}
      >
        {title}
      </a>
    </div>
  )
}

HeaderAction.propTypes = {
  title: PropTypes.string.isRequired,
  hideUnder: PropTypes.number,
  isCentered: PropTypes.bool,
  right: PropTypes.bool,
  redirectUrl: PropTypes.string,
  isButton: PropTypes.bool,
  dataAttr: PropTypes.string
}

export default HeaderAction
